import React from 'react';
import { Button, Dropdown, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const items = [
    { key: 'en', label: '🇬🇧 English', onClick: () => i18n.changeLanguage('en') },
    { key: 'ar', label: '🇸🇦 العربية', onClick: () => i18n.changeLanguage('ar') },
  ];

  return (
    <Dropdown menu={{ items, selectable: true, selectedKeys: [i18n.language] }} trigger={['click']}>
      <Button
        type="text"
        icon={<GlobalOutlined style={{ color: '#F1F5F9' }} />}
        style={{ color: '#F1F5F9' }}
      >
        {i18n.language === 'ar' ? 'العربية' : 'English'}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
